var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ededed",
    height: "200px",
    width: "200px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-25.6 -25.6 307.20 307.20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M245,176v80H10v-80h57v22H43v30h167v-30h-19v-22H245z M29,111V0h58v23.7C97,27.5,105.1,35,108.6,45H182v26 v147H75v-59.4c-1,0.2-1.5,0.2-2,0.2c-1.1,0-1.8-0.2-2.3-0.2c-0.9-0.3-2.1-0.7-2.8-1.2c-1-0.7-1.9-1.8-2.6-2.7 c-0.5-0.9-0.9-2-1.1-2.8c-0.2-0.7-0.1-1.6-0.1-2.5v-46.3c0-1.9-1.9-3.8-4-3.8c-1.9,0-4,1.6-4,3.8v36.7c-1,0-1.6,0-2.1-0.2 c-3.1-0.7-6-2.8-7-5.8c-0.5-1-0.9-2.3-0.9-3.5V99.3c0-1.9-1.4-3.8-3.5-3.8c-1.9,0-3.5,1.6-3.5,3.8v21.3C34,120.6,29,116.4,29,111z M108,132h5c1,6,4.7,8.4,8.9,8.4c4.2,0,7-2.6,8.9-7.8c1.6-3.8,2.4-5.6,4.4-5.6c1.6,0,3,1.6,3,4.5c0,3-0.9,5-1.4,6.3l5.4,1.5 c0.9-1.7,1.6-4.3,1.6-7.3h4.3v-4h-4.5c-1-5-4.4-7.8-8.7-7.8c-4.4,0-7.2,3.5-8.9,8.6c-1.4,3.7-2.4,5.1-4.4,5.1s-3.3-1.8-3.3-4.9 c0-3,0.9-6,1.9-7.7l-5.6-1.5c-0.7,1.6-1.7,5.3-1.7,8.3H108V132z M83,194.1c7.9,2.3,14.2,8.6,16.6,16.6l58.8-0.1 c2.4-7.9,8.7-14.2,16.6-16.5V70c-8-2.4-14.4-8.8-16.7-16.9l-0.2,0c0,0,0-0.1,0-0.1h-0.2c0,0,0,0.1,0,0.1l-47.7,0.1 c0,1,0.1,45.2,0.1,59.3c4.6-4.6,10.9-7.4,17.9-7.4c14,0,25.3,11.4,25.3,25.3s-11.4,25.3-25.3,25.3s-25.3-11.4-25.3-25.3 c0-1.5,0.1-3,0.4-4.5c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.2,0-0.2,0c-0.6,0-1.3,0.2-1.8,0.2c-5.4,0-9.8-4.4-9.8-9.7 c0-0.7,0.1-34.7,0.1-34.7c0-1.9-1.8-3.8-3.9-3.8c-1.8,0-2.9,1.4-3.9,3.3V194.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.af449995968294e5e922685ffae527bf.svg";
export { ForwardRef as ReactComponent };